import { z } from 'zod';

export enum SiteOperationalPhase {
  PLANNING = 'Planning',
  COMMISSIONING = 'Commissioning',
  IN_OPERATION = 'In Operation',
  MONITORING_ENDED = 'Monitoring Ended',
  END_OF_LIFE = 'End Of Life',
}

export const SiteOperationalPhaseSchema = z.nativeEnum(SiteOperationalPhase);
